export const config = [
	{ key: 'MailIn', label: 'Mail-In' },
	{ key: 'CallIn', label: 'Call-In' },
	{ key: 'Lighthouse', label: 'Lighthouse' },
	{ key: 'Economy', label: 'Economy' },
	{ key: 'Bonus', label: 'Bonus' },
]
